export default "__VITE_ASSET__F1WLWolY__"